<template>
    <div class="caseBox">
        <el-tabs v-model="activeName" >
<!--            全部案件-->
            <el-tab-pane label="全部案件" name="first">
                <allCases></allCases>
            </el-tab-pane>
<!--            待我处理-->
            <el-tab-pane label="待我处理" name="second">
                <waitMe></waitMe>
            </el-tab-pane>
<!--            待代理人处理-->
            <el-tab-pane label="待代理人处理" name="third">
                <waitLawyer></waitLawyer>
            </el-tab-pane>
<!--            处理中-->
            <el-tab-pane label="处理中" name="fourth">
                <processing></processing>
            </el-tab-pane>
<!--            已结案-->
            <el-tab-pane label="已结案" name="fifth">
                <caseClosed></caseClosed>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import allCases from "./components/allCases";
    import waitMe from "./components/waitMe";
    import waitLawyer from "./components/waitLawyer";
    import processing from "./components/processing"
    import caseClosed from "./components/caseClosed";

    export default {
        name: "case",
        data() {
            return {
                activeName: 'first'
            };
        },
        components:{
            allCases,
            waitMe,
            waitLawyer,
            processing,
            caseClosed
        }
    }
</script>

<style scoped>
    .caseBox{
        background-color: #fff;
        padding: 30px;
    }
    /deep/.el-tabs__item{
        padding: 0px 40px;
    }
    /deep/.el-tabs__active-bar{
        background-color: #3b63f6;
    }
    /deep/.is-active{
        font-size: 16px;
        color: #3b63f6;
    }

</style>
